import './styles/app.css'
import './styles/flipbook.css'
import 'vuetify/styles'
import * as CookieConsent from 'vanilla-cookieconsent'

export const app = {
  mounted () {
    this.$nextTick(() => {
      // add cookie bar here
      window.addEventListener('scroll', this.onScroll)

      // Registrable domain GA uses for its cookies (cookie_domain: 'auto').
      // We must erase _ga* on this same domain, otherwise opt-out leaves them
      // behind on any multi-label host (e.g. .pracevefabce.cz / .arodax.dev).
      const cookieDomain = (() => {
        const host = window.location.hostname
        const parts = host.split('.')
        for (let i = parts.length - 2; i >= 0; i--) {
          const candidate = parts.slice(i).join('.')
          document.cookie = `__cc_probe=1; domain=${candidate}; path=/`
          if (document.cookie.indexOf('__cc_probe=1') !== -1) {
            document.cookie = `__cc_probe=; domain=${candidate}; path=/; expires=Thu, 01 Jan 1970 00:00:01 GMT`
            return candidate
          }
        }
        return host
      })()

      // cookie consent
      CookieConsent.run({
        cookie: {
          name: 'cc_pracevefabce_cz'
        },
        root: '#app',
        mode: 'opt-in',
        autoShow: true,
        revision: 1,
        manageScriptTags: true,
        autoClearCookies: true,
        hideFromBots: true,
        disablePageInteraction: false,
        categories: {
          analytics: {
            autoClear: {
              cookies: [
                { name: /^_ga/, domain: cookieDomain }
              ]
            }
          },
        },
        language: {
          default: 'cs',
          autoDetect: 'document',
          translations: {
            cs: {
              preferencesModal: {
                title: 'Používáme cookies!',
                acceptAllBtn: 'Přijmout vše',
                acceptNecessaryBtn: 'Přijmout nezbytné',
                savePreferencesBtn: 'Uložit nastavení',
                closeIconLabel: 'Zavřít',
                sections: [
                  {
                    title: 'Nezbytné cookies',
                    description: 'Tyto cookies jsou nezbytné pro správné fungování našich webových stránek.',
                    linkedCategory: 'necessary'
                  },
                  {
                    title: 'Analytické cookies',
                    description: 'Tyto cookies využívají službu Google Analytics 4 a pomáhají nám měřit návštěvnost a zlepšovat obsah webu. Aktivují se pouze s vaším souhlasem.',
                    linkedCategory: 'analytics',
                    cookieTable: {
                      headers: {
                        name: 'Jméno',
                        domain: 'Služba',
                        description: 'Popis',
                        expiration: 'Expirace'
                      },
                      body: [
                        {
                          name: '_ga',
                          domain: 'Google',
                          description: 'Google Analytics – rozlišuje jednotlivé návštěvníky.',
                          expiration: '400 dní'
                        },
                        {
                          name: '_ga_5NH9GFW1KW',
                          domain: 'Google',
                          description: 'Google Analytics 4 – uchovává stav relace.',
                          expiration: '400 dní'
                        }
                      ]
                    }
                  },
                  {
                    title: 'Více informací',
                    description: 'Další informace o našich cookies a ochraně osobních údajů najdete <a href="/zpracovani-osobnich-udaju" target="_blank">zde</a>.'
                  }
                ]
              },
              consentModal: {
                label: 'Nastavení cookies',
                title: 'Používáme cookies!',
                description: 'Některé cookies jsou nezbytné pro správné fungování našich webových stránek. Jiné cookies nám pomáhají zlepšit vaše uživatelské zkušenosti. Nastavte své preference a zjistěte více o našich cookies.',
                acceptAllBtn: 'Přijmout vše',
                acceptNecessaryBtn: 'Přijmout nezbytné',
                showPreferencesBtn: 'Nastavení cookies',
                footer: '<a href="/zpracovani-osobnich-udaju" target="_blank">Zpracování osobních údajů</a>'
              }
            }
          }
        },
        guiOptions: {
          consentModal: {
            layout: 'box'
          },
          preferencesModal: {
            layout: 'box'
          }
        }
      })
    })
  },
  components: {

  },
  data () {
    return {
      menu: false,
      offsetTop: 0
    }
  },
  methods: {
    toggleMainMenu () {
      this.menu = !this.menu
    },
    onScroll () {
      this.offsetTop = window.scrollY
    },
    showCookieSettings () {
      CookieConsent.showPreferences()
    }
  }
}
